export const videoText = "Видео";
export const videoDescriptionText = "(до 2 мин)";